import { baseColors } from "@Constants/baseStyles"
import * as React from "react"
import Svg, { Path } from "react-native-svg"

function SvgTropheeIcon(props) {
    return (
        <Svg xmlns="http://www.w3.org/2000/svg" width={27} height={27} fill="none" viewBox="0 0 27 27" {...props}>
            <Path
                fill="#FAD207"
                d="M18.362 19.72l-4.941.544-4.892-.543c2.314 0 3.126-1.657 3.284-3.848.02-.29.03-.59.03-.896v-.207a7.86 7.86 0 001.657.17 7.92 7.92 0 001.603-.157v.194c0 .31.008.613.03.907.149 2.186.92 3.837 3.23 3.837z"
            />
            <Path
                fill="#FAD207"
                d="M20.21 20.871v1.838l-6.764.543-6.764-.543V20.87c0-.635.515-1.15 1.15-1.15H19.06a1.15 1.15 0 011.15 1.15z"
            />
            <Path
                fill="#FAA515"
                d="M20.16 20.536H8.04c-.3 0-.543.243-.543.543v1.63h-.815V20.87c0-.635.515-1.15 1.15-1.15H19.06c.518 0 .957.343 1.1.815zm-5.028-4.653a9.188 9.188 0 01-1.632.143 9.083 9.083 0 01-1.687-.154c.02-.29.03-.59.03-.895v-.207l1.657-.065 1.603.077v.195c0 .31.008.612.03.906z"
            />
            <Path
                fill="#FAD207"
                d="M27 5.514c0 4.029-3.278 7.307-7.307 7.307h-1.06a8.902 8.902 0 001.235-1.633 5.687 5.687 0 005.444-4.859h-3.699c.115-.592.196-1.145.253-1.63h4.32c.449 0 .814.365.814.815z"
            />
            <Path
                fill="#FAA515"
                d="M21.219 10.983a12.3 12.3 0 01-.419.763 10.46 10.46 0 01-.724 1.065c-.127.007-.255.01-.383.01h-1.06l.121-.78 1.113-.852s.92-.085 1.352-.206zM22.96 4.7c-.006.041-.01.083-.015.126a23.42 23.42 0 01-.227 1.503h-1.105l-.402-.815.655-.815h1.093z"
            />
            <Path
                fill="#FAD207"
                d="M27 5.514c0 3.9-3.073 7.097-6.924 7.297.257-.331.499-.688.724-1.066.146-.244.286-.498.419-.762a5.694 5.694 0 004.093-4.654H22.72a23.375 23.375 0 00.24-1.63h3.226c.45 0 .815.365.815.815zM8.366 12.82h-1.06C3.279 12.82 0 9.544 0 5.515c0-.45.365-.815.815-.815h4.32c.056.485.137 1.038.252 1.63h-3.7a5.687 5.687 0 005.445 4.86 8.9 8.9 0 001.234 1.632z"
            />
            <Path
                fill="#FAA515"
                d="M5.387 6.329H4.281a23.583 23.583 0 01-.24-1.63h1.093l.657.834-.404.796zm2.979 6.492H7.307c-.128 0-.256-.003-.382-.01-.257-.33-.5-.687-.725-1.065a11.98 11.98 0 01-.419-.763c.432.121 1.352.206 1.352.206l1.014.717.22.915z"
            />
            <Path
                fill={baseColors.black}
                d="M22.328 22.708H4.672c-.6 0-1.087.486-1.087 1.087v2.118c0 .6.487 1.087 1.087 1.087h17.656c.6 0 1.086-.487 1.086-1.087v-2.119c0-.6-.486-1.086-1.086-1.086z"
            />
            <Path
                fill={baseColors.black}
                d="M5.758 27H4.672c-.6 0-1.087-.486-1.087-1.087v-2.119c0-.6.487-1.086 1.087-1.086v3.205c0 .6.486 1.087 1.086 1.087z"
            />
            <Path
                fill="#FAD207"
                d="M22.002 2.77s0 .413-.053 1.087a22.384 22.384 0 01-.336 2.472c-.298 1.527-.821 3.312-1.745 4.86a8.9 8.9 0 01-1.234 1.632c-.91.94-2.064 1.658-3.531 1.961a7.92 7.92 0 01-1.603.158 7.88 7.88 0 01-1.657-.17c-1.44-.309-2.578-1.02-3.477-1.95a8.898 8.898 0 01-1.233-1.632c-.925-1.547-1.448-3.332-1.746-4.86a22.279 22.279 0 01-.336-2.471c-.053-.674-.053-1.086-.053-1.086h17.004z"
            />
            <Path
                fill={baseColors.green.primary}
                d="M13.774 5.17l.667 2.054h2.16c.28 0 .395.357.17.52l-1.748 1.27.668 2.055a.288.288 0 01-.444.321L13.5 10.12l-1.747 1.27a.288.288 0 01-.443-.321l.667-2.055-1.747-1.27a.288.288 0 01.169-.52h2.16l.667-2.054a.288.288 0 01.548 0z"
            />
            <Path fill={baseColors.green.dark} d="M18.47 25.288H8.53a.407.407 0 110-.814h9.94a.407.407 0 110 .814z" />
            <Path
                fill="#FAA515"
                d="M22.002 2.77l-8.852-.542-7.065.543H4.998s0 .413.053 1.086a22.49 22.49 0 00.336 2.472c.298 1.527.821 3.312 1.746 4.86.35.587.758 1.14 1.233 1.632.899.93 2.036 1.64 3.477 1.95a8.405 8.405 0 002.199.153 7.628 7.628 0 01-1.112-.154c-1.441-.308-2.579-1.02-3.477-1.949a8.9 8.9 0 01-1.234-1.632c-.924-1.548-1.448-3.333-1.745-4.86A22.284 22.284 0 016.22 4.7v-.01a.747.747 0 01.743-.833h14.986c.053-.673.053-1.086.053-1.086z"
            />
            <Path fill="#FAD207" d="M4.97 0h17.06a1.385 1.385 0 010 2.77H4.97a1.385 1.385 0 010-2.77z" />
            <Path
                fill="#FAA515"
                d="M6.057 2.77H4.971a1.386 1.386 0 010-2.77h1.086a1.382 1.382 0 00-1.385 1.385c0 .765.62 1.386 1.385 1.386z"
            />
        </Svg>
    )
}

export default SvgTropheeIcon
